export const universityCoachRequest = {
    path: '/coach-request/:uuid',
    component: () => import("@/layouts/CoachRequest.vue"),
    meta: {
        label: 'Coach Request'
    }
}